var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcShareBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication / Share_Android"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.132812)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.13281 13.5L15.1328 16.5M15.1328 7.5L9.13281 10.5M18.1328 21C16.476 21 15.1328 19.6569 15.1328 18C15.1328 16.3431 16.476 15 18.1328 15C19.7897 15 21.1328 16.3431 21.1328 18C21.1328 19.6569 19.7897 21 18.1328 21ZM6.13281 15C4.47596 15 3.13281 13.6569 3.13281 12C3.13281 10.3431 4.47596 9 6.13281 9C7.78967 9 9.13281 10.3431 9.13281 12C9.13281 13.6569 7.78967 15 6.13281 15ZM18.1328 9C16.476 9 15.1328 7.65685 15.1328 6C15.1328 4.34315 16.476 3 18.1328 3C19.7897 3 21.1328 4.34315 21.1328 6C21.1328 7.65685 19.7897 9 18.1328 9Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareBl);
export default __webpack_public_path__ + "static/media/ic_share_bl.1654c93d022de5b5441f97c3747bce92.svg";
export { ForwardRef as ReactComponent };